<app-site-energy-consumption [tooltips]="'site_energy_consumption'"></app-site-energy-consumption>
<app-site-energy-report></app-site-energy-report>
<app-meter-energy-report></app-meter-energy-report>
<app-energy-consumption-charts></app-energy-consumption-charts>
